import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from "@mui/material";
import MDButton from "components/MDButton";
import { useTranslation } from "react-i18next";

const DeleteConfirmation = (props) => {
    const {confirmationDialogOpen,setConfirmationDialogOpen ,deleteId,handleProductDelete,dataFrom } = props;
    const { t } = useTranslation();

    const handleConfirmationDialogClose = () => {
        setConfirmationDialogOpen(false);
      };
    
      const handleConformationClose = () => {
        handleProductDelete(deleteId);
        setConfirmationDialogOpen(false);
      }

    return (
        <Dialog open={confirmationDialogOpen} onClose={handleConfirmationDialogClose}>
            <DialogTitle>{t(dataFrom+"ConfirmDelete")}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {t(dataFrom+"DeleteMessage")}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <MDButton onClick={handleConfirmationDialogClose} color="primary">
                    {t("cancel")}
                </MDButton>
                <MDButton onClick={handleConformationClose} color="secondary">
                    {t("delete")}
                </MDButton>
            </DialogActions>
        </Dialog>
    )
}
export default DeleteConfirmation;